// | This module re-exports the types for the `HTML` DSL, and values for all
// | supported HTML elements.
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Halogen$dComponent from "../Halogen.Component/index.js";
import * as Halogen$dVDom$dThunk from "../Halogen.VDom.Thunk/index.js";
import * as Halogen$dVDom$dTypes from "../Halogen.VDom.Types/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
const slot_ = () => dictIsSymbol => dictOrd => {
  const componentSlot2 = Halogen$dComponent.componentSlot()(dictIsSymbol)(dictOrd);
  return label => p => component => input => Halogen$dVDom$dTypes.$VDom(
    "Widget",
    Halogen$dComponent.$ComponentSlot("ComponentSlot", componentSlot2(label)(p)(component)(input)(v => Data$dMaybe.Nothing))
  );
};
const slot = () => dictIsSymbol => dictOrd => {
  const componentSlot2 = Halogen$dComponent.componentSlot()(dictIsSymbol)(dictOrd);
  return label => p => component => input => outputQuery => Halogen$dVDom$dTypes.$VDom(
    "Widget",
    Halogen$dComponent.$ComponentSlot("ComponentSlot", componentSlot2(label)(p)(component)(input)(x => Data$dMaybe.$Maybe("Just", outputQuery(x))))
  );
};
const memoized = eqFn => f => x => Halogen$dVDom$dTypes.$VDom(
  "Widget",
  Halogen$dComponent.$ComponentSlot("ThunkSlot", Halogen$dVDom$dThunk.thunk({f}, ($0, $1) => eqFn($0)($1), f, x))
);
const lazy3 = f => a => b => c => Halogen$dVDom$dTypes.$VDom("Widget", Halogen$dComponent.$ComponentSlot("ThunkSlot", Halogen$dVDom$dThunk.thunk3(f, a, b, c)));
const lazy2 = f => a => b => Halogen$dVDom$dTypes.$VDom("Widget", Halogen$dComponent.$ComponentSlot("ThunkSlot", Halogen$dVDom$dThunk.thunk2(f, a, b)));
const lazy = f => a => Halogen$dVDom$dTypes.$VDom("Widget", Halogen$dComponent.$ComponentSlot("ThunkSlot", Halogen$dVDom$dThunk.thunk1(f, a)));
const fromPlainHTML = Unsafe$dCoerce.unsafeCoerce;
export {fromPlainHTML, lazy, lazy2, lazy3, memoized, slot, slot_};
